import Vue from 'vue';
import Vuex from 'vuex';
import signUp from './modules/signUp.js'

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    signUp,
  },
});

export default store;